import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { SearchInputComponent } from '../../../components/search-input/search-input.component';
import { SvgIconComponent } from '../../../components/svg-icons/svg-icon.component';
import { ButtonComponent } from '../../../components/button/button.component';
import { NavigateLinkDirective } from '../../directives/navigate-link/navigate-link.directive';
import { NavigationState } from '../../services/navigation-state.service';
import { FlatButtonDirective } from '../../directives/flat-button/flat-button.directive';
import { ProductRequestSearchProvider } from '../../../components/search-input/providers/product-request-search.provider';
import { Router } from '@angular/router';
import { ManagedProductSearchProvider } from '../../../components/search-input/providers/managed-product-search.provider';
import { ProductRequestSearchUseCase } from '../../../pages/bulletin-board/product-request-search.usecase';
import { ManagedProductSearchUseCase } from '../../../pages/managed-product/managed-product-search.usecase';

@Component({
  selector: 'app-navigation',
  imports: [
    CommonModule,
    MatRippleModule,
    SearchInputComponent,
    SvgIconComponent,
    ButtonComponent,
    NavigateLinkDirective,
    FlatButtonDirective,
  ],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
})
export class NavigationComponent {
  readonly #router = inject(Router);
  readonly #navigationState = inject(NavigationState);
  isMobileNavigationOpened = this.#navigationState.isMobileNavVisible;
  readonly productRequestSearchProvider = inject(ProductRequestSearchProvider);
  readonly managedProductSearchProvider = inject(ManagedProductSearchProvider);
  readonly #productRequestSearchUseCase = inject(ProductRequestSearchUseCase);
  readonly #managedProductSearchUseCase = inject(ManagedProductSearchUseCase);

  get keywordControl() {
    // URLが/managed-productだった場合はmanagedProductSearchUseCaseのformControlを返す
    if (this.#router.url.startsWith('/managed-product')) {
      return this.#managedProductSearchUseCase.formModel.formGroup.controls.keyword;
    }
    return this.#productRequestSearchUseCase.formModel.formGroup.controls.keyword;
  }

  get searchProvider() {
    // URLが/managed-productだった場合はmanagedProductSearchProviderを返す
    if (this.#router.url.startsWith('/managed-product')) {
      return this.managedProductSearchProvider;
    }
    return this.productRequestSearchProvider;
  }

  openMobileNav() {
    this.#navigationState.setMobileNavigationListVisibility(true);
  }

  closeMobileNav() {
    this.#navigationState.setMobileNavigationListVisibility(false);
  }
}
